import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { DeleteConfirmationDialogComponent } from './delete-confirmation-dialog/delete-confirmation-dialog.component';

@NgModule({
  declarations: [
    ConfirmationDialogComponent,
    DeleteConfirmationDialogComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ConfirmationDialogComponent,
    DeleteConfirmationDialogComponent
  ]
})
export class SharedModule { } 